import React,{useState} from 'react'
import { AppBar, Box, Divider, Drawer, IconButton, Toolbar, Typography } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu';
import {NavLink} from 'react-router-dom';
import '../../Style/Headerstyle.css';
import Logo from '../../images/logo.svg';
const Header = () => {
  const [mobileopen, setmobileopen] = useState(false);

  //handel menu click
  const handleDrawerToggle = () => {
    setmobileopen(!mobileopen);
  }
  //menu drawer  mobile 
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{textAlign: 'center'}}>
         <Typography color={'goldenrod'} variant='h6' component={'div'} sx={{flexGrow:1, my:2}}>
         <img src={Logo} alt="logo" height={'70px'} width={'200px'} />
                </Typography>
              <Divider/>
                   <ul className='mobile-navigation'>
                    <li>
                    <NavLink activeClassName="active" to={'/'}>Home</NavLink>
                    </li>
                    <li>
                        <NavLink to={'/menu'}>Menu</NavLink>
                    </li>
                    <li>
                        <NavLink to={'/about'}>About</NavLink>
                    </li>
                    <li>
                        <NavLink to={'/contact'}>Contact</NavLink>
                    </li>
                   </ul>
              
    </Box>
  )
  return (
    <>
       <Box>
          <AppBar component={'nav'} sx={{bgcolor:"black"}}>
             <Toolbar> 
              <IconButton color='inherit' aria-lable="open Drawer" edge="start" 
              sx={{mr:2, display: {sm: 'none'}}}
              onClick={handleDrawerToggle}>
                <MenuIcon/>
                </IconButton>
                <Typography color={'goldenrod'} variant='h6' component={'div'} sx={{flexGrow:1}}>
                  <img src={Logo} alt="logo" height={'70px'} width={'250px'} />
                </Typography>
                <Box sx={{display:{xs:'none', sm:'block'}}}>
                   <ul className='navigation-menu'>
                    <li>
                        <NavLink activeClassName="active" to={'/'}>Home</NavLink>
                    </li>
                    <li>
                        <NavLink to={'/menu'}>Menu</NavLink>
                    </li>
                    <li>
                        <NavLink to={'/about'}>About</NavLink>
                    </li>
                    <li>
                        <NavLink to={'/contact'}>Contact</NavLink>
                    </li>
                   </ul>
                </Box>
              </Toolbar>
          </AppBar>
          <Box component='nav'>
            <Drawer variant='temporary' open={mobileopen}
             onClose={handleDrawerToggle}
             sx={{ display: {xs:'block',sm:'none'}, "& .MuiDrawer-paper":{
                 boxSizing: 'border-box',
                 width: '250px',
             } }} >
              {drawer}
            </Drawer>
          </Box>
          <Box>
          <Toolbar/>
          </Box> 
       </Box>
    </>
  )
}

export default Header
